import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { A6EventRow, useA6EventColumns } from "./columns";
import { FilterA6Events, type FilterA6EventsSchema } from "./filter";

const client = "a6";
const table_name = "a6_events";

export function A6EventsTable() {
  const { t } = useTranslation();
  const columns = useA6EventColumns();

  return (
    <Table<A6EventRow, FilterA6EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterA6Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
